import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicOnlyRoute = ({ children }) => {
  const { hasToken } = useSelector((state) => state.user);

  return hasToken ? <Navigate to='/' replace /> : children;
};

export default PublicOnlyRoute;
